/****************************************************
 * Module Name:  stoneSelectionModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Box, Button, TextField, } from "@mui/material";
import "./../../style/modalstyle.css";
import logo from '../../images/pansuriya.jpg'
import Constants from "../../utility/constants";
import { Modal } from "react-bootstrap";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const CriteriaLinkModal = ({ guid, handleClose, show }) => {

    const criteriaLink = `${window.location.origin}/app/operation/stock?id=${guid}`;

    const [buttonText, setButtonText] = useState("Copy Link");

    const handleCopy = (message) => {
        navigator.clipboard.writeText(message);
        setButtonText("Link Copied");
    };

    const openLinkInNewTab = () => {
        window.open(criteriaLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <div>
            <Modal show={show} onHide={handleClose} enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp; Link
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box
                        sx={{
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                color: "#1976d2",
                                padding: "4px 5px",
                                borderRadius: "4px",
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                color: "#1976d2",
                                padding: "5px 5px",
                                borderRadius: "4px",
                            },
                            height: "20vh",
                        }}
                    >
                        <TextField
                            margin="normal"
                            fullWidth
                            value={criteriaLink}
                        />
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        sx={{ mr: 1 }}
                        variant="contained"
                        color="primary"
                        onClick={() => openLinkInNewTab()}
                        startIcon={<OpenInNewIcon />}
                    >
                        Open
                    </Button>
                    <Button
                        sx={{ mr: 1 }}
                        variant="contained"
                        color="success"
                        onClick={() => handleCopy(criteriaLink)}
                        startIcon={<FileCopyRoundedIcon />}
                    >
                        {buttonText}
                    </Button>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CriteriaLinkModal;